<template>
  <div
    class="relative flex flex-col items-center w-full pt-8 pb-6 transition-opacity bg-white border-2 border-solid rounded border-i4m-orange"
    :class="disabled && 'opacity-50 pointer-events-none'"
    :style="{ maxWidth: '460px' }"
  >
    <div
      v-if="tailored"
      class="absolute top-0 left-0 px-4 py-1 text-sm italic font-bold text-white rounded md:text-lg bg-i4m-orange"
      :style="{ left: '50%', transform: 'translateX(-50%)', top: '-16px' }"
    >
      SU MISURA PER TE!
    </div>

    <div v-if="blurred" class="blurred"></div>

    <!-- insurance provider -->
    <div class="flex items-center mb-5" :class="logoLayout.container">
      <svgicon
        :name="`companies/${offer.company.url_logo}`"
        width="100%"
        :height="logoLayout.logoHeight"
        :original="true"
        class="mr-6"
      ></svgicon>

      <div class="flex items-start" :class="logoLayout.byI4M">
        <div class="">Offerta emessa da</div>
        <div class="font-bold">INSURANCE4MUSIC</div>
      </div>
    </div>

    <company-coverages :coverages="offer.company.coverages"></company-coverages>

    <!-- price -->
    <div class="mb-1 text-center opacity-75">A partire da</div>
    <div class="flex items-baseline">
      <euro-value
        :value="blurred ? 8 : offer.value"
        class="text-4xl font-bold"
        smallerDecimals
        symbolBefore
        hideDecimalsIfZero
      />

      <div class="ml-1 text-sm opacity-75">/ anno</div>
    </div>
    <scalapay-widget
      :amount="offer.value"
      locale="it"
      currencyPosition="after"
      logoColor="#ed8936"
      class="mb-5"
    ></scalapay-widget>

    <!-- cta -->
    <a-button type="primary" class="flex-shrink-0" @click="$emit('pick')" :loading="loading">
      Scegli
    </a-button>
  </div>
</template>

<script>
export default {
  name: 'offer',
  props: ['offer', 'tailored', 'blurred', 'disabled', 'loading'],
  computed: {
    logoLayout() {
      const vertical = {
        byI4M: 'flex flex-row gap-1',
        container: 'flex flex-col',
        logoHeight: '64',
      };
      const horizontal = { byI4M: 'flex-col', container: '', logoHeight: '85' };

      if (this.offer.company.name === 'Oney') return vertical;

      return horizontal;
    },
  },

  methods: {
    showCoveragesDetails(e) {
      e.preventDefault();
      window.open(this.offer.company.coverages.link, '_blank');
    },
  },
};
</script>

<style lang="scss">
.blurred {
  position: absolute;
  top: 20px;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.4);
  backdrop-filter: blur(6px);
}
</style>
